import videojs from 'video.js';
import './iframe.js';

class Games extends videojs.getPlugin('plugin') {
	constructor(player, options) {
		super(player);
		this.options = options;
		this.showIframeButton = null;
		this.player.ready(() => {
			this.init();
		});
	}

	init() {
		this.player.addClass('vjs-games');
		this.addShowIframeButton();
		this.update();
	}

	addShowIframeButton() {
		this.showIframeButton = this.player.addChild('Button', {
			clickHandler: () => {
				this.showIframe();
			},
			controlText: 'Game',
			className: 'vjs-games__button vjs-visible-text'
		});
	}

	showIframe() {
		let playedSeconds = 0;
		let playingIntervalId;

		const seekWithReplay = (seconds) => {
			const duration = this.player.duration();
			const currentTime = this.player.currentTime();
			let seekTime = currentTime + seconds;

			if (seekTime < duration) {
				this.player.currentTime(seekTime);
				return;
			}

			// Доматываем плеер на доступное время и воспроизводим видео заново.
			const availableSeekTime = duration - currentTime;
			this.player.currentTime(availableSeekTime);
			this.player.currentTime(0);
		}

		if (!this.player.paused()) {
			this.player.pause();

			playingIntervalId = setInterval(() => {
				playedSeconds += 1;

				if (playedSeconds === 60) {
					playedSeconds -= 60;
					seekWithReplay(60);
				}
			}, 1000);

			this.player.trigger('Game/open');
		}

		this.player.addChild('GamesIframe', {
			className: 'vjs-games__iframe',
			src: this.options.getURL(),
			onDispose: () => {
				if (!playingIntervalId) return;
				clearInterval(playingIntervalId);
				seekWithReplay(playedSeconds);
				this.player.play();
				this.player.trigger('Game/close');
			}
		});
	}

	update() {
		if (!this.showIframeButton) {
			return;
		}
		if (this.options.hasURL()) {
			this.showIframeButton.show();
		} else {
			this.showIframeButton.hide();
		}
	}
}

// Cross-compatibility for Video.js 5 and 6.
const registerPlugin = videojs.registerPlugin || videojs.plugin;
registerPlugin('games', Games);
